module.exports = __webpack_public_path__ + "img/csjs.8e7d284d.png";